module.exports = __webpack_public_path__ + "img/low-do.90dc8de8.png";